export const removeUndefinedValues = (obj: Object) => {
  return JSON.parse(JSON.stringify(obj));
}

export const empty = data => {
  if (typeof data === 'number' || typeof data === 'boolean') {
    return false;
  }
  if (typeof data === 'undefined' || data === null) {
    return true;
  }
  if (typeof data.length !== 'undefined') {
    return data.length === 0;
  }
  let count = 0;
  for (const i in data) {
    if (data.hasOwnProperty(i)) {
      count++;
    }
  }
  return count === 0;
};
